import React from "react";
import {
  FaBookOpen,
  FaClock,
  FaUserGraduate,
  FaLaptopCode,
  FaChalkboardTeacher,
  FaCheckCircle,
} from "react-icons/fa";

const iconColorMap = {
  FaBookOpen: "text-blue-500",
  FaClock: "text-teal-500",
  FaCheckCircle: "text-green-500",
  FaChalkboardTeacher: "text-purple-500",
  FaLaptopCode: "text-orange-500",
  FaUserGraduate: "text-yellow-500",
};

const packages = [
  {
    title: "Knowledge Knights",
    subtitle: "OC Preparation Package",
    description: "Best for students targeting OC (Opportunity Class) entrance exams",
    points: [
      { icon: <FaBookOpen className={iconColorMap["FaBookOpen"]} />, text: "Practice Sets (English, Mathematics, Thinking Skills)" },
      { icon: <FaClock className={iconColorMap["FaClock"]} />, text: "Weekly Tests – 52 Weeks Coverage" },
      { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "English, Mathematics, Thinking Skills" },
      { icon: <FaChalkboardTeacher className={iconColorMap["FaChalkboardTeacher"]} />, text: "One-on-One Lessons (optional)" },
      { icon: <FaLaptopCode className={iconColorMap["FaLaptopCode"]} />, text: "Book-based & Digital Learning Materials" },
    ],
    priceNote: "Starting from $XX/Hour",
    color: "from-purple-500 to-teal-400",
    shadow: "shadow-purple-300",
    badge: "bg-purple-100 text-purple-700",
  },
  {
    title: "Selective Students Achievements",
    subtitle: "4/5/6 Gladiators Package",
    description: "Best for high performers aiming for Selective Schools entry from Years 4 to 6",
    points: [
      { icon: <FaUserGraduate className={iconColorMap["FaUserGraduate"]} />, text: "Maths Practice Sessions" },
      { icon: <FaClock className={iconColorMap["FaClock"]} />, text: "Weekly Tests – 52 Weeks Coverage" },
      { icon: <FaCheckCircle className={iconColorMap["FaCheckCircle"]} />, text: "Creative Writing, English, Mathematics, Thinking Skills" },
      { icon: <FaChalkboardTeacher className={iconColorMap["FaChalkboardTeacher"]} />, text: "One-on-One Lessons (optional)" },
    ],
    priceNote: "Starting from $XX/Hour",
    color: "from-orange-500 to-blue-400",
    shadow: "shadow-orange-300",
    badge: "bg-orange-100 text-orange-700",
  },
];

export default function Pricing() {
  return (
    <div className="bg-teal-50 min-h-screen py-10 sm:py-20 px-4 sm:px-6 md:px-10">
      <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-800 mb-8 sm:mb-16">
        Choose Your Path to Success
      </h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
        {packages.map((pkg, index) => (
          <div
            key={index}
            className={`relative p-[2px] rounded-3xl bg-gradient-to-br ${pkg.color} ${pkg.shadow} hover:shadow-lg sm:hover:shadow-xl transition`}
          >
            <div className="bg-white rounded-3xl p-6 sm:p-8 h-full">
              <div className={`inline-block px-3 py-1 text-xs sm:text-sm rounded-full font-semibold mb-3 sm:mb-4 ${pkg.badge}`}>
                {pkg.subtitle}
              </div>
              <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900">{pkg.title}</h3>
              <p className="text-xs sm:text-sm text-gray-600 mt-1 sm:mt-2 mb-4 sm:mb-6">{pkg.description}</p>

              <ul className="space-y-3 sm:space-y-4 border-l-4 border-teal-400 pl-4 sm:pl-6">
                {pkg.points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-2 sm:gap-3">
                    <span className="mt-0.5 sm:mt-1 text-sm sm:text-base">{point.icon}</span>
                    <p className="text-gray-800 text-sm sm:text-base">{point.text}</p>
                  </li>
                ))}
              </ul>

              <div className="mt-6 sm:mt-8 text-base sm:text-lg font-bold text-teal-700">
                {pkg.priceNote}
              </div>
              <button className="mt-3 sm:mt-4 w-full sm:w-auto rounded-full px-6 sm:px-10 py-2 sm:py-3 text-sm sm:text-md font-semibold bg-yellow-400 text-white shadow-sm sm:shadow-md hover:bg-orange-500 transition duration-300 flex items-center justify-center gap-2">
                Book Now!
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}